import * as Braze from '@braze/web-sdk';

import config from '@config';
import type { IBrazeService } from './BrazeService';

class BrazeService implements IBrazeService {
  init() {
    Braze.initialize(config.BRAZE_WEB_API_KEY, {
      baseUrl: config.BRAZE_SDK_ENDPOINT,
      allowUserSuppliedJavascript: true,
    });
    Braze.openSession();
  }

  setUserId(id: string) {
    Braze.changeUser(id);
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  getInitialURL(): Promise<null> {
    return Promise.resolve(null);
  }

  subscribeToInAppMessage() {
    Braze.subscribeToInAppMessage((inAppMessage) => {
      Braze.showInAppMessage(inAppMessage);
    });
  }

  trackEvent(name: string, params?: Record<string, any>) {
    try {
      if (__DEV__) {
        const evParams = JSON.stringify(params);
        const analytic = `Braze analytics trackEvent:${name}, params:${evParams}`;
        return console.log(analytic);
      }

      Braze.logCustomEvent(name, params);
    } catch (error) {
      // Do nothing
    }
  }

  trackUserParams(params: Record<string, any>) {
    try {
      const user = Braze.getUser();

      Object.keys(params).forEach((key) => {
        if (__DEV__) {
          const analytic = `Braze analytics trackUserParams:${key}, val:${params[key]}`;
          return console.log(analytic);
        }

        if (key === 'email') {
          user?.setEmail(params[key]);
        }

        user?.setCustomUserAttribute(key, params[key]);
      });
    } catch (error) {
      // Do nothing
    }
  }
}

export default new BrazeService();
